// extracted by mini-css-extract-plugin
export default {"icon":"_5cKCjQLsw1bEcRG8DpqOq6","right":"dvizgYFdtwAaRjtyiHMXC","left":"_7ugjYXXXoAh98lbc5C9V6d","spin":"_46AWSd4oLAGAj50tpW5zWm","pulse":"_15N11S8LDOXSEUZWUxKJ5b"};